// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import Switch from "@mui/material/Switch";

var Styles = {
  tab: "md:text-[13px] md:min-w-[48px]"
};

var allRegions = [
  "global",
  "br1",
  "eun1",
  "euw1",
  "jp1",
  "kr",
  "la1",
  "la2",
  "me1",
  "na1",
  "oc1",
  "ru",
  "sg2",
  "tr1",
  "tw2",
  "vn2"
];

function useRenderElements(param) {
  var match = React.useState(function () {
        return 40;
      });
  var setRenderElements = match[1];
  var throttle = React.useRef(false);
  React.useEffect((function () {
          var screenSize = ScreenAtom.getSize(ScreenAtom.getWidth(undefined));
          if (screenSize >= 4) {
            var cb = function (param) {
              var sh = document.documentElement.scrollHeight;
              var scrollY = window.scrollY | 0;
              var ih = window.innerHeight;
              if ((sh - (scrollY + ih | 0) | 0) < 500 && !throttle.current) {
                Curry._1(setRenderElements, (function (re) {
                        if (re < 1000) {
                          return re + 40 | 0;
                        } else {
                          return re;
                        }
                      }));
                throttle.current = true;
                setTimeout((function (param) {
                        throttle.current = false;
                        return cb(undefined);
                      }), 350);
                return ;
              }
              
            };
            window.addEventListener("scroll", cb, {
                  passive: true,
                  capture: false,
                  once: false
                });
            return (function (param) {
                      window.removeEventListener("resize", cb);
                      
                    });
          }
          Curry._1(setRenderElements, (function (param) {
                  return 1000;
                }));
          
        }), []);
  return match[0];
}

function LbUtils$PatchStatsToggle(Props) {
  var usePatchStats = Props.usePatchStats;
  var setUsePatchStats = Props.setUsePatchStats;
  return React.createElement("div", {
              className: "flex items-center font-semibold"
            }, React.createElement("div", {
                  className: "select-none cursor-pointer pr-1 " + (
                    usePatchStats ? "text-white2" : "text-primary-11a"
                  ),
                  onClick: (function (param) {
                      return Curry._1(setUsePatchStats, (function (v) {
                                    return !v;
                                  }));
                    })
                }, "Season Stats"), React.createElement(Switch, {
                  checked: usePatchStats,
                  onChange: (function (e) {
                      var v = e.target.checked;
                      return Curry._1(setUsePatchStats, (function (param) {
                                    return v;
                                  }));
                    }),
                  size: "small"
                }), React.createElement("div", {
                  className: "select-none cursor-pointer pl-1 " + (
                    usePatchStats ? "text-primary-11a" : "text-white2"
                  ),
                  onClick: (function (param) {
                      return Curry._1(setUsePatchStats, (function (v) {
                                    return !v;
                                  }));
                    })
                }, "Patch Stats"));
}

var make = React.memo(LbUtils$PatchStatsToggle);

var PatchStatsToggle = {
  make: make
};

export {
  Styles ,
  allRegions ,
  useRenderElements ,
  PatchStatsToggle ,
  
}
/* make Not a pure module */
